import { Box, Button, Typography } from "@mui/material";
import { Component, ErrorInfo, ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Uncaught render error:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            textAlign: "center",
            px: 2,
            gap: 2,
          }}
        >
          <Typography color="text.secondary">
            Noe gikk galt. Prøv å laste siden på nytt.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Last siden på nytt
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
